import IconBin from 'assets/icons/bin.svg';
import { FilterConfig } from 'interfaces/collection-filter';
import { CollectionProduct } from 'models/collection/collection';
import { Gtm } from 'tracking';
import { FormattedMessage } from 'react-intl';
import FilterGroup from '../../filter-group';

interface FilterLaptopProps {
  appliedFilter: string[];
  filterConfig: FilterConfig | undefined;
  activeAllergyFilter: string[];
  resetFilter: () => void;
  toggleFilter: (value: string) => void;
  collectionProducts: CollectionProduct[];
  visibleProducts: CollectionProduct[];
}

const FilterLaptop: React.FC<FilterLaptopProps> = ({
  appliedFilter,
  filterConfig,
  activeAllergyFilter,
  resetFilter,
  toggleFilter,
  collectionProducts,
  visibleProducts,
}) => {
  const numberOfActiveFilters = appliedFilter.length + activeAllergyFilter.length;

  if (!filterConfig) return null;

  return (
    <div data-test="collection-filter" className="">
      <div className="mb-4 flex items-center justify-between text-xs">
        <span className="text-sm leading-[21px] font-medium">
          <FormattedMessage id="cdp:filter:label" />
        </span>
        {numberOfActiveFilters > 0 && (
          <button
            className="text-text-secondary flex shrink-0 items-center gap-2 text-xs leading-[18px] font-medium"
            onClick={() => {
              Gtm.track.selectElement({
                element: ['Filter', 'Unselect All'],
              });
              resetFilter();
            }}
          >
            <IconBin className="inline-block h-3 w-3" />
            <FormattedMessage id="cdp:resetfilters" />
          </button>
        )}
      </div>

      {filterConfig && (
        <div className="flex-auto px-0">
          {filterConfig && (
            <FilterGroup
              filterConfig={filterConfig}
              toggleFilter={toggleFilter}
              appliedFilter={appliedFilter}
              collectionProducts={collectionProducts}
              visibleProducts={visibleProducts}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default FilterLaptop;
